import { useEffect, useState } from 'react'
import { getProvinceCities } from '../store/features/basicInfo/basicInfoSlice'
import { TOptions } from '../types/generalType'
import { useAppDispatch, useAppSelector } from './useStore'

type UseCitiesType = (provinceId: string | number) => {
  cityLoadin: boolean
  citiesSelectOptions: TOptions[]
}

const useCities: UseCitiesType = (provinceId) => {
  const dispatch = useAppDispatch()

  const { ciyList } = useAppSelector((state) => state.basicInfo.province)
  const [citiesSelectOptions, setCitiesSelectOptions] = useState<TOptions[]>([])

  useEffect(() => {
    const cityQuery = {
      pageSize: 100,
      pageNumber: 1,
      provinceId,
    }
    if (provinceId) dispatch(getProvinceCities(cityQuery))
  }, [provinceId])

  useEffect(() => {
    const newCityList: TOptions[] = ciyList?.list?.map((city) => ({
      value: String(city.id),
      label: city.title,
    }))
    setCitiesSelectOptions(newCityList)
  }, [ciyList?.list?.length, provinceId])

  return {
    cityLoadin: ciyList.loading,
    citiesSelectOptions,
  }
}

export default useCities
